import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function PFDataTable({
  data,
  columns,
  paginator,
  loading,
  lazy,
  rows,
  first,
  rowsPerPageOptions,
  tableStyle,
  className,
  onPage,
  totalRecords,
  handleDelete,
  onSort,
  dataTableParams,
  filters,
  onFilter,
  columnStyle,
  rowExpansionTemplate,
  expandedRows,
  onRowToggle,
  sortField,
  sortOrder,
  stripedRows,
  onFilterClear,
  ...rest
}) {
  return (
    <DataTable
      loading={loading || false}
      value={data || []}
      paginator={paginator || false}
      lazy={lazy || false}
      rows={rows || 0}
      first={first || 0}
      rowsPerPageOptions={rowsPerPageOptions || ''}
      tableStyle={tableStyle || null}
      className={`w-12 ${className ? className : ''} pf-data-table p-datatable-striped`}
      onPage={onPage || null}
      totalRecords={totalRecords || 0}
      handleDelete={handleDelete}
      onSort={onSort}
      filters={filters}
      onFilter={onFilter}
      {...dataTableParams}
      rowExpansionTemplate={rowExpansionTemplate}
      expandedRows={expandedRows}
      onRowToggle={onRowToggle}
      sortField={sortField}
      sortOrder={sortOrder}
      stripedRows={stripedRows || true}
      size="small"
      onFilterClear={onFilterClear}
      {...rest}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    >
      {columns?.map((col, index) => {
        const {
          field,
          header,
          sortable,
          filter,
          body,
          filterElement,
          filterField,
          filterPlaceholder,
          filterClear,
          filterApply,
          filterIcon,
          showFilterMatchModes,
          style,
          showFilterMenu,
          showFilterMenuOptions,
          showFilterOperator,
          showClearButton,
          showAddButton,
          expander,
          rowEditor,
          editor,
          hidden,
          frozen,
          onCellEditComplete,
          colSpan,
          pt,
        } = col;
        return (
          <Column
            key={index}
            field={field || null}
            header={header || null}
            sortable={sortable || false}
            filter={filter || null}
            body={body || null}
            filterElement={filterElement || null}
            filterField={filterField || null}
            filterPlaceholder={filterPlaceholder || null}
            filterClear={filterClear || null}
            filterApply={filterApply || null}
            filterIcon={filterIcon || null}
            showFilterMatchModes={showFilterMatchModes || false}
            style={columnStyle ? columnStyle : style || ''}
            showFilterMenu={showFilterMenu || true}
            showFilterMenuOptions={showFilterMenuOptions || false}
            showFilterOperator={showFilterOperator || false}
            showClearButton={showClearButton || false}
            showAddButton={showAddButton || false}
            expander={expander || null}
            rowEditor={rowEditor || null}
            editor={editor || null}
            hidden={hidden || undefined}
            frozen={frozen || false}
            onCellEditComplete={onCellEditComplete || null}
            colSpan={colSpan || false}
            pt={pt || null}
          ></Column>
        );
      })}
    </DataTable>
  );
}
